export const requestToPayStatesData = [
    {
        option: 'Accepted',
        value: 'ACCEPTED',
        css: 'green'
    },
    {
        option: 'Failed',
        value: 'FAILED',
        css: 'red'
    },
    {
        option: 'In progress',
        value: 'IN_PROGRESS',
        css: 'orange'
    },
    {
        option: '',
        value: 'UNKNOWN',
        hidden: true
    }
];